import styled from '@emotion/styled';
import Box from '@mui/material/Box';

const Styled = styled(Box)``;

export default Styled;
